<template>
<v-app>
  <div class="week-selector">
    <v-select
      :items="weekOptions"
      v-model="weekIndex"
      @change="fetchWeek(weekOptions[weekIndex].iso)"
      label="Week"
    />
  </div>

  <div class="listing">
    <p
      v-if="!(weekOptions[weekIndex].iso in eventsByWeek)"
      style="text-align: center;"
    >Loading...</p>
    <p
      v-if="(weekOptions[weekIndex].iso in eventsByWeek) && eventsByWeek[weekOptions[weekIndex].iso].length === 0"
      style="text-align: center;"
    >Nothing on this week!</p>
    <Weekday
      v-for="i in weekdayIndexes"
      :key="i"
      :weekIso="weekOptions[weekIndex].iso"
      :weekDay="i"
      :weekEvents="eventsByWeek[weekOptions[weekIndex].iso]"
    />
  </div>

  <div class="print-never">
    <div class="show-more print-never">
      <v-btn
        @click="nextWeek()"
        :disabled="nextWeekClicked || (weekIndex === weekOptions.length - 1)"
      >Next week</v-btn>
    </div>
  </div>

  <section id="submit" class="submit print-never">
    <h2 class="submit__title">Submit Your Event</h2>
    <div id="submit-form">
        <SubmitForm />
    </div>
  </section>
</v-app>
</template>

<script>
import { range } from 'ramda';
import moment from 'moment';
import SubmitForm from './SubmitForm';
import Weekday from './Weekday';

moment.updateLocale("en", {
  week: {
    dow: 1,
    doy: 4
  }
});

const weekOptions = range(0, 54)
  .map(n =>
    moment.utc()
      .startOf('week')
      .add(n, 'week')
  ).map((m, i) => (
    {
      text: `${m.format("dddd Do MMMM YYYY")} - ${m.clone().add(1, 'week').subtract(1, 'day').format("dddd Do MMMM YYYY")}`,
      iso: m.toISOString(),
      value: i
    }
  ));

export default {
  name: 'App',
  data: function () {
    return {
      eventsByWeek: {},
      weekIndex: 0,
      nextWeekClicked: false,
      weekOptions,
      weekdayIndexes: range(0, 7)
    }
  },
  created: function () {
    this.fetchThisWeek();
  },
  computed: {
  },
  methods: {
    nextWeek: async function () {
      this.nextWeekClicked = true;
      this.weekIndex += 1;
      await this.fetchThisWeek();
      window.scrollTo(0, 0);
      this.nextWeekClicked = false;
    },
    fetchThisWeek: async function () {
      await this.fetchWeek(this.weekOptions[this.weekIndex].iso);
    },
    fetchWeek: async function (week) {
      if (week in this.eventsByWeek) {
        return;
      }
      const req = await fetch(`events.php?start_date=${week}&count=100`);
      const json = await req.json();
      const events = json.filter(
        (event) =>
          moment.utc(event.start)
            .isBetween(moment.utc(week), moment.utc(week).add(1, 'week'))
      )
      this.$set(this.eventsByWeek, week, events);
    }
  },
  components: {
    Weekday,
    SubmitForm
  }
}
</script>

<style>
.show-more {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
